import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  /** 뎁스1 카테고리 개수 */
  $cateCount: number;
}

// 뎁스1 영역 디자인 스펙 (Category-On)
const DPT1_TOP_PAD = 24; // 상단 여백
const DPT1_TITLE_HEIGHT = 17; // 타이틀 높이 (line-height)
const DPT1_GAP = 30; // 타이틀 간 간격
const DPT1_BOTTOM_PAD = 40; // 하단 여백
const DPT1_STEP = DPT1_TITLE_HEIGHT + DPT1_GAP; // 타이틀 top 간격 47px

export const CateAreaDesktop = styled.div<IProps>`
  display: inline-block;

  .gnb-cate-btn {
    width: 40px;
    height: 40px;
    border-radius: 7px;
    border: 1px solid #e2e2e2;
    position: relative;

    &:hover:after {
      content: '';
      display: block;
      width: 26px;
      height: 38px;
      background: transparent;
      position: absolute;
      top: 0;
      left: 38px;
      /* background-color: red; */
    }
  }

  .gnb-cate-list {
    position: absolute;
    background-color: #fff;
    left: 0;
    top: 121px;
    z-index: 1;
    width: 100%;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 28px;
      background: transparent;
      position: absolute;
      top: -28px;
      left: 0;
      /* background-color: blue; */
    }
  }

  .inner-gcl {
    position: relative;
    max-width: 1920px;
    margin: 0 auto;
    ${mixin.flex({
      justify: 'flex-start',
      align: 'stretch',
    })};
    /* background-color: blue; */
  }

  .cate-list {
    padding-left: 20px;
    width: 100%;
    /* 마지막 타이틀 top + 타이틀 높이 + 하단 여백 = 뎁스1 개수만큼 최소 높이 확보 */
    min-height: ${({ $cateCount }) =>
      DPT1_TOP_PAD +
      ($cateCount - 1) * DPT1_STEP +
      DPT1_TITLE_HEIGHT +
      DPT1_BOTTOM_PAD}px;

    .btn {
      ${mixin.flex({ justify: 'space-between' })}

      > span {
        text-align: left;
        ${mixin.ellipsis(1)}
      }
    }

    .title-dpt1 {
      width: 132px;
      font-size: 17px;
      font-weight: 500;
      line-height: 17px;
      position: absolute;
      z-index: 2;
      background-color: #fff;
      text-transform: uppercase;
      /* background-color: red; */
    }

    .title-dpt2 {
      font-size: 14px;
      font-weight: 500;
      line-height: 18.2px;
      text-transform: uppercase;

      &:hover {
        text-decoration: underline;
      }
    }

    .list-dpt1 {
      > li {
        overflow: hidden;
        ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })}

        /* 뎁스1 개수만큼 타이틀 top 자동 배치 */
        ${({ $cateCount }) =>
          Array.from(
            { length: $cateCount },
            (_, i) => css`
              &:nth-child(${i + 1}) .title-dpt1 {
                top: ${DPT1_TOP_PAD + i * DPT1_STEP}px;
              }
            `
          )}
      }
    }

    .list-dpt2 {
      background-color: #fff;
      position: relative;
      display: none;
      padding: 24px 20px 40px 20px;
      width: 100%;
      margin-left: 144px; // #2
      margin-top: -56px; // #2
      max-width: 1040px; // #2
      min-width: 880px; // #2
      min-height: 322px; // #2
      /* background: orange; */

      > li {
        width: 160px;
        z-index: 1;
        float: left; // #2
        margin-left: 8px; // #2
        margin-top: 56px; // #2
      }

      // #2
      &:after {
        content: '';
        display: block;
        clear: both;
      }
    }

    .list-dpt3 {
      margin-top: 12px;

      > li {
        margin-top: 8px;
        min-height: 16px;

        &:first-child {
          margin-top: 0;
        }
      }

      .btn {
        font-size: 14px;
        font-weight: 400;
        color: #7b7b7b;
        line-height: 18.2px;
        text-transform: uppercase;
        width: 100%;

        &:hover {
          color: #000;
        }
      }
    }

    .list-dpt1 > li.active .title-dpt1:after {
      content: '';
      display: inline-block;
      width: 0;
      height: 0;
      border-bottom: 6px solid transparent;
      border-top: 6px solid transparent;
      border-left: 10px solid #000;
      position: absolute;
      right: 0;
    }

    .list-dpt1 > li.active .list-dpt2 {
      display: block; // #2
    }
  }

  .aside-list {
    background-color: #f9f9f9;
    padding: 24px 20px 40px 36px;
    ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })}
    column-gap : 8px;
    width: 100%;
    max-width: 707px;
    min-width: 322px;

    .list {
      font-size: 14px;
      line-height: 18.2px;
      width: 168px;

      dt {
        font-weight: 500;
        color: #000;
        margin-bottom: 12px;
      }

      dd {
        color: #777;
        margin-top: 8px;

        .btn {
          &:hover {
            color: #000;
          }
        }

        &.dot {
          .btn:after {
            content: '';
            display: inline-block;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: #fa5500;
            margin-left: 2px;
            transform: translateY(-6px);
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.x4l} {
    // flex 레이아웃 변경 / 스포츠/액티브 제외
    .cate-list .list-dpt1 > li:not([data-mediumcd='M51282714']) {
      .list-dpt2 {
        gap: 56px 8px;
        margin-left: 152px; // #2
        margin-top: 0; // #2
        max-width: 1040px; // #2
        min-width: 1040px; // #2

        > li {
          float: none; // #2
          margin-left: 0; // #2
          margin-top: 0; // #2
        }

        // #2
        &:after {
          display: none;
        }
      }

      &.active .list-dpt2 {
        ${mixin.flex({
          wrap: 'wrap',
          justify: 'flex-start',
          align: 'stretch',
        })};
      }
    }

    // 스포츠/액티브 flot 적용
    .cate-list .list-dpt1 > li[data-mediumcd='M51282714'] .list-dpt2 {
      margin-left: 152px; // #2
      min-width: 1040px; // #2
      padding-left: 10px; // #2
    }
  }
`;
